import { useState } from "react";

import { useSelector } from "react-redux";

import { Link } from "react-router";

import { ListItemText, Button, Typography, Menu, MenuItem, ListItemIcon } from "@mui/material"

import { FaPlus } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { FaList } from "react-icons/fa";
import { FaRegFileAlt } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";
import { MdSend } from "react-icons/md";
import { BiImport } from "react-icons/bi";

import { RootState } from "../../store";

import { ListItembuttonStyle, ListItemIconStyle, ListTypographyStyle, MenuItemStyle, TypographyAppBarStyle, ListItemTextStyle } from '../../styles/ListItemStyle';

import { DialogNuevoAcuerdo } from "../../dialogs/DialogNuevoAcuerdo";
import { DialogNuevaListaAcuerdos } from "../../dialogs/DialogNuevaListaAcuerdos";
import { DialogNuevaListaEstrados } from "../../dialogs/DialogNuevaListaEstrados";
import { DialogNuevoOficio } from "../../dialogs/DialogNuevoOficio";
import { DialogNuevoExhortoLibrado } from "../../dialogs/DialogNuevoExhortoLibrado";
import { DialogNuevaCertificacion } from "../../dialogs/DialogNuevaCertificacion";
import { DialogNuevoListadoEnvio } from "../../dialogs/DialogNuevoListadoEnvio";
import { DialogNuevaNotificacion } from "../../dialogs/DialogNuevaNotificacion";
import { DialogNuevaSentencia } from "../../dialogs/DialogNuevaSentencia";
import { DialogNuevaSentenciaPublica } from "../../dialogs/DialogNuevaSentenciaPublica";
import { DialogCelebrarAudiencia } from "../../dialogs/DialogCelebrarAudiencia";

export const ListItemNuevo = () => {

    const { roles } = useSelector( ( state: RootState ) => state.auth );

    const [anchorEl, anchorElOpen] = useState<null | HTMLElement>( null );

    const [openNuevoAcuerdo, setOpenNuevoAcuerdo] = useState( false );
    const [openCelebrarAudiencia, setOpenCelebrarAudiencia] = useState( false );
    const [openNuevaSentencia, setOpenNuevaSentencia] = useState( false );
    const [openNuevaSentenciaPublica, setOpenNuevaSentenciaPublica] = useState( false );
    const [openNuevoOficio, setOpenNuevoOficio] = useState( false );
    const [openNuevoExhortoLibrado, setOpenNuevoExhortoLibrado] = useState( false );
    const [openNuevaCertificacion, setOpenNuevaCertificacion] = useState( false );
    const [openNuevaNotificacion, setOpenNuevaNotificacion] = useState( false );
    const [openNuevaListaAcuerdos, setOpenNuevaListaAcuerdos] = useState( false );
    const [openNuevaListaEstrados, setOpenNuevaListaEstrados] = useState( false );
    const [openNuevoListadoEnvio, setOpenNuevoListadoEnvio] = useState( false );

    return (
        <>

            <ListItemText style={ ListItemTextStyle }>

                <Button color="inherit" style={ ListItembuttonStyle } onClick={ (e) => anchorElOpen( e.currentTarget ) }>

                    <FaPlus style={ ListItemIconStyle } />

                    <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                        Nuevo
                    </Typography>

                    <FaChevronDown style={ ListItemIconStyle } />
                                            
                </Button>

            </ListItemText>  

            <Menu 
                elevation={ 2 } 
                anchorEl={ anchorEl } 
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} 
                keepMounted open={ Boolean( anchorEl ) } 
                onClose={ () => anchorElOpen( null ) }
            >

                {
                    ( roles?.ElaboradorAcuerdo || roles?.ElaboradorAcuerdoOficioso )
                    &&
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevoAcuerdo( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaEdit /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar acuerdo</ListItemText>
                        </MenuItem>   
                }

                {
                    roles?.CelebradorAudiencia 
                    && 
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenCelebrarAudiencia( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaEdit /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar Audiencia</ListItemText>
                        </MenuItem>                    
                }
           
                {
                    roles?.ElaboradorSentencia 
                    && 
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevaSentencia( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaEdit /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar sentencia</ListItemText>
                        </MenuItem>
                }
                
                {
                    roles?.ElaboradorSentenciaPublica 
                    && 
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevaSentenciaPublica( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaEdit /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar sentencia pública</ListItemText>
                        </MenuItem>
                }

                {
                    roles?.ElaboradorOficio 
                    && 
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevoOficio( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaEdit /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar oficio</ListItemText>
                        </MenuItem>
                }

                {
                    roles?.ElaboradorExhortoLibrado 
                    &&                        
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevoExhortoLibrado( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaEdit /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar exhorto librado</ListItemText>
                        </MenuItem>   
                }        

                {
                    roles?.ElaboradorCertificacion 
                    &&           
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevaCertificacion( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaEdit /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar certificación</ListItemText>
                        </MenuItem>   
                }
                
                {
                    roles?.GeneradorNotificacion 
                    && 
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevaNotificacion( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <MdSend fontSize={18} /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar notificación</ListItemText>
                        </MenuItem>
                }              

                {
                    roles?.GeneradorCaratulas 
                    &&
                        <Link to="/tribunal/caratula/generar" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { anchorElOpen( null ); } }> 
                                <ListItemIcon sx={{ textAlign: 'center' }}> <FaRegFileAlt fontSize={18} /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Generar carátulas</ListItemText>
                            </MenuItem>
                        </Link>   
                }
                
                {
                    roles?.GeneradorListaAcuerdos 
                    &&                      
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevaListaAcuerdos( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaList /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar lista de acuerdos</ListItemText>
                        </MenuItem> 
                }    

                {
                    roles?.GeneradorListaEstrados
                    &&                      
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevaListaEstrados( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaList /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar lista de estrados</ListItemText>
                        </MenuItem> 
                }    
            
                {
                    roles?.GeneradorListadoEnvio 
                    &&                    
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenNuevoListadoEnvio( true ); anchorElOpen( null ); } }> 
                            <ListItemIcon sx={{ textAlign: 'center' }}> <FaList /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar listado envío</ListItemText>
                        </MenuItem>                                            
                }

                {
                    roles?.RegistrarExpedienteAnterior 
                    &&           
                        <Link to="/tribunal/importar/expediente" style={{ textDecoration: 'none' }}>          
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }}> 
                                <ListItemIcon sx={{ textAlign: 'center' }}> <BiImport style={{ fontSize: 20 }} /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Importar expediente</ListItemText>
                            </MenuItem>                        
                        </Link>                      
                }

                {
                    roles?.RegistrarExhortoAnterior 
                    &&         
                        <Link to="/tribunal/importar/exhorto" style={{ textDecoration: 'none' }}>          
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }}> 
                                <ListItemIcon sx={{ textAlign: 'center' }}> <BiImport style={{ fontSize: 20 }} /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Importar exhorto</ListItemText>
                            </MenuItem>                        
                        </Link>  
                }

            </Menu>

            <DialogNuevoAcuerdo
                openDialog={ openNuevoAcuerdo }
                handleCloseDialog={ () => setOpenNuevoAcuerdo( false ) }
            />

            <DialogCelebrarAudiencia
                openDialog={ openCelebrarAudiencia }
                handleCloseDialog={ () => setOpenCelebrarAudiencia( false ) }
            />

            <DialogNuevaSentencia
                openDialog={ openNuevaSentencia }
                handleCloseDialog={ () => setOpenNuevaSentencia( false ) }
            />

            <DialogNuevaSentenciaPublica
                openDialog={ openNuevaSentenciaPublica }
                handleCloseDialog={ () => setOpenNuevaSentenciaPublica( false ) }
            />
         
            <DialogNuevaListaAcuerdos
                openDialog={ openNuevaListaAcuerdos }
                handleCloseDialog={ () => setOpenNuevaListaAcuerdos( false ) }
            />
         
            <DialogNuevaListaEstrados
                openDialog={ openNuevaListaEstrados }
                handleCloseDialog={ () => setOpenNuevaListaEstrados( false ) }
            />
           
            <DialogNuevoOficio
                openDialog={ openNuevoOficio }
                handleCloseDialog={ () => setOpenNuevoOficio( false ) }
            />
      
            <DialogNuevoExhortoLibrado
                openDialog={ openNuevoExhortoLibrado }
                handleCloseDialog={ () => setOpenNuevoExhortoLibrado( false ) }
            />

            <DialogNuevaCertificacion
                openDialog={ openNuevaCertificacion }
                handleCloseDialog={ () => setOpenNuevaCertificacion( false ) }
            />
      
            <DialogNuevoListadoEnvio
                openDialog={ openNuevoListadoEnvio }
                handleCloseDialog={ () => setOpenNuevoListadoEnvio( false ) }
            />
            
            <DialogNuevaNotificacion
                openDialog={ openNuevaNotificacion }
                handleCloseDialog={ () => setOpenNuevaNotificacion( false ) }
            />
            
        </>
    )
}
